export function Empty({ msg = "데이터가 없습니다" }: { msg?: string }) {
  return (
    <div style={{ textAlign: "center", padding: 48, color: "var(--text-3)", fontSize: 13 }}>
      {msg}
    </div>
  );
}

export function Loading() {
  return <div style={{ textAlign: "center", padding: 48, color: "var(--text-3)", fontSize: 13 }}>불러오는 중…</div>;
}
